import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	base: {
		flexGrow: 1,
		flexShrink: 0,
	},
});
